import { Box, Card, GridItem, Icon, Typography } from "@drone-js/core";
import type { Amenity } from "libs/codegen/property-onboarding";
import type { FunctionComponent } from "react";
import { defaultIcon, iconsMap } from "./constants";

interface Props extends Amenity {
    onClick?: () => void;
    selected: boolean;
}

export const AmenityCard: FunctionComponent<Props> = ({ selected, onClick, id, name }) => {
    const icons = iconsMap[id] ?? defaultIcon;
    const cardStatus = selected ? "selected" : "default";

    return (
        <GridItem sm={6} md={4} lg={3}>
            <Card
                type="interactive"
                variant="outlined"
                p="16"
                status={cardStatus}
                onClick={onClick}
                height="100%"
                minHeight="89px"
                data-element-name="amenities"
                amenity-card-status={cardStatus}
                amenity-id={id}
            >
                <Box>
                    <Icon
                        id={selected ? icons[1] : icons[0]}
                        color={selected ? "product.primary" : "base.default"}
                        size="24"
                    />
                    <Box mt="12">
                        <Typography variant="body-s-strong" textColor={selected ? "product.primary" : "base.default"}>
                            {name}
                        </Typography>
                    </Box>
                </Box>
            </Card>
        </GridItem>
    );
};
